
export default function init() {

  if (!blago_ajax.is_mobile) {
    import('@dotlottie/player-component');
  } else {
    return;
  }
      
  const preloader = document.querySelector('.cbb-preloader');
  const mainContent = document.getElementById('main-content');

  let lottieCompletedCount = 0;
  let isHidden = false;

  const lottieAnimations = [
    document.querySelector('#lottie1 dotlottie-player'),
    document.querySelector('#lottie2 dotlottie-player')
  ].filter(Boolean);

  function hidePreloader() {
    if (isHidden) return;
    isHidden = true;
    preloader?.classList.add('hide');
    setTimeout(() => {
      preloader?.remove();
      if (mainContent) mainContent.style.display = 'block';
    }, 600);
  }

  function tryHidePreloader() {
    if (!isHidden && lottieCompletedCount === lottieAnimations.length) {
      hidePreloader();
    }
  }

  lottieAnimations.forEach(lottie => {
    lottie.addEventListener('ready', () => {
      const anim = lottie.getLottie ? lottie.getLottie() : null;
      if (!anim) {
        lottieCompletedCount++;
        tryHidePreloader();
        return;
      }

      anim.addEventListener('complete', () => {
        lottieCompletedCount++;
        tryHidePreloader();
      });
    });
  });

  setTimeout(hidePreloader, 5000);
}

